import SeoPageLayout from "@/components/SeoPageLayout";

const KabaretNaSpotkanieFirmowe = () => (
  <SeoPageLayout title="Kabaret na spotkanie firmowe - humor, który łączy">
    <p>
      Spotkanie firmowe to okazja do integracji zespołu, podsumowania wyników i planowania przyszłości. Kabaret na spotkanie firmowe dodaje lekkości i humoru, sprawiając, że nawet najbardziej formalne spotkanie staje się przyjemnością.
    </p>

    <h2 className="text-2xl font-bold text-foreground mt-10">Kabaret jako element spotkania firmowego</h2>
    <p>
      Występ kabaretowy może stanowić przerwę między oficjalnymi prezentacjami, zakończenie dnia konferencyjnego lub główną atrakcję wieczornej części spotkania. Elastycznie dopasowujemy formę do harmonogramu wydarzenia.
    </p>

    <h2 className="text-2xl font-bold text-foreground mt-10">Rodzaje spotkań firmowych z kabaretem</h2>
    <ul className="list-disc pl-6 space-y-2">
      <li>Spotkania kwartalne - humorystyczne podsumowanie wyników</li>
      <li>Kick-off meeting - energetyczny start nowego projektu</li>
      <li>Spotkanie roczne - komediowy przegląd roku</li>
      <li>Town hall meeting - lekki przerywnik w oficjalnej agendzie</li>
      <li>Spotkanie integracyjne - humor budujący relacje w zespole</li>
    </ul>

    <h2 className="text-2xl font-bold text-foreground mt-10">Elastyczna forma występu</h2>
    <p>
      Na spotkanie firmowe oferujemy różne formaty - od krótkiego 15-minutowego przerywnika po pełny 60-minutowy występ. Możemy też wcielić się w rolę prowadzącego spotkanie, dodając humoru do prezentacji i dyskusji.
    </p>
  </SeoPageLayout>
);

export default KabaretNaSpotkanieFirmowe;
